import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'
import { Network } from '@root/entities/network/model'
import { type Pair } from '@root/entities/pair/model'
import { PlatformUtil } from '@root/shared'
import { useDateFormat } from '@root/shared/localization'
import { ReservedSpace, SolScanIcon } from '@root/shared/ui-kit'

import { usePairAgeFormatted } from '../../hooks'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: Pair.PairMinimal
  size?: number
} & ClassNameProps

export const PairInformationAge: React.FC<Props> = ({
  pair,
  size = 14,
  className,
}) => {
  const { formatted: pairAge } = usePairAgeFormatted(pair.createdAt)
  const { formatDate } = useDateFormat()

  const handleExploreOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    e.preventDefault()

    const explorerLink = Network.makeExplorerContractLink(
      pair.quote.network,
      pair.quote.address,
    )
    PlatformUtil.openLink(explorerLink)
  }

  if (pairAge) {
    return (
      <Tooltip
        content={
          pair.createdAt ? formatDate(pair.createdAt, 'PPpp') : undefined
        }
      >
        <Root className={className}>
          <Link onClick={handleExploreOpen}>
            <SolScanIcon size={size} />
          </Link>
          <Age onClick={handleExploreOpen}>
            <ReservedSpace $chars={pairAge.length}>{pairAge}</ReservedSpace>
          </Age>
        </Root>
      </Tooltip>
    )
  }
}

const Root = styled.span`
  pointer-events: auto;
  color: var(--up-9);

  font-weight: 500;
  font-size: 12px;
  font-style: normal;
  line-height: 16px;

  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 4px;

  svg {
    color: var(--text-11);
  }
`

const Link = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  color: var(--appearance-inv-1);
  cursor: pointer;

  &:visited {
    color: var(--appearance-inv-1);
  }
`

const Age = styled.span`
  cursor: pointer;
`
